
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bEmzp", function(module, exports) {
/* PopupPreview.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $jSnXV = parcelRequire("jSnXV");


var $g5lKx = parcelRequire("g5lKx");


var $caX7N = parcelRequire("caX7N");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");





var $a5rdE = parcelRequire("a5rdE");

const $df08ca4e4b70ce05$var$TIME_SPENT_OVER_PREVIEW = 2000;
const $df08ca4e4b70ce05$export$c97368b009d9ec7f = ({ children: children, source: source })=>{
    const { fireAnalyticsEventWithTemplateData: fireAnalyticsEventWithTemplateData } = (0, $42omo.useContext)((0, $a5rdE.PreviewAnalyticsContext));
    const timeout = (0, $42omo.useRef)(null);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        if (timeout.current) return;
        timeout.current = window.setTimeout(()=>{
            fireAnalyticsEventWithTemplateData({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'hovered',
                    actionSubject: 'templatePreview'
                }
            });
        }, $df08ca4e4b70ce05$var$TIME_SPENT_OVER_PREVIEW);
    }, [
        fireAnalyticsEventWithTemplateData,
        source
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }, children));
};




/* PreviewFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $bUlM5 = parcelRequire("bUlM5");


var $6mKj3 = parcelRequire("6mKj3");


var $9xorX = parcelRequire("9xorX");


var $c2cyb = parcelRequire("c2cyb");


var $c5QRx = parcelRequire("c5QRx");

const $a3457201b6f3f636$var$TEMPLATE_INFO_HEIGHT = 53;
const $a3457201b6f3f636$var$TEMPLATE_INFO_HEIGHT_WITH_BUTTON = 64;
const $a3457201b6f3f636$var$PREVIEW_MIN_HEIGHT = 540;
const $a3457201b6f3f636$var$PREVIEW_MIN_WIDTH = 480;
const $a3457201b6f3f636$var$TEMPLATE_PANEL_WIDTH = 400;
const $a3457201b6f3f636$var$SHORT_BROWSER_HEIGHT = (0, $c5QRx.TOP_BAR_HEIGHT) + (0, $c5QRx.VERTICAL_MARGIN) * 2 + $a3457201b6f3f636$var$PREVIEW_MIN_HEIGHT;
const $a3457201b6f3f636$var$NARROW_BROWSER_WIDTH = $a3457201b6f3f636$var$TEMPLATE_PANEL_WIDTH + (0, $c5QRx.DISTANCE_FROM_ITEM) + $a3457201b6f3f636$var$PREVIEW_MIN_WIDTH;
const $a3457201b6f3f636$var$styles = {
    templateInfoContainer: "_1bsb1osq",
    templateInfo: "_1reo15vq _18m915vq _1o9zkb7n _1ul9idpf"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3457201b6f3f636$var$TemplateContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isBottomPositioned: isBottomPositioned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71bhr _2rkofajl _1bsb1xbk _p12f1ogm _1ul91y37 _1tke1w2c _16qs130s _1e0c1txw _2lx21bp4 _1mfcglyw _y8wh1riq _aepw1riq",
            __cmplp.isBottomPositioned ? "_4t3i1us8" : "_4t3iap9j",
            __cmplp.isBottomPositioned ? "_c71l9gu9" : "_c71lepgg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3457201b6f3f636$var$TemplateInfo = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $7sObp.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4ojaz _n7zlia51 _4t3i2nrh _1o9zidpf _16jlidpf _vchhusvi _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3457201b6f3f636$var$TemplateName = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81e3o _1reo15vq _18m915vq _18u01b66 _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3457201b6f3f636$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { templateInfoHeight: templateInfoHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gf3hfn": (0, $7sObp.default)(__cmplp.templateInfoHeight, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n",
            __cmplp.templateInfoHeight ? "_4t3izo7p" : "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $a3457201b6f3f636$export$633731da8c821a2a = ({ template: template, spaceKey: spaceKey, hidePreview: hidePreview, children: children, isBottomPositioned: isBottomPositioned = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3457201b6f3f636$var$TemplateContainer, {
        isBottomPositioned: isBottomPositioned
    }, template && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3457201b6f3f636$var$TemplateInfo, {
        height: (0, $6mKj3.expVal)('confluence_cwr_template_right_rail', 'isEnabled', false) ? $a3457201b6f3f636$var$TEMPLATE_INFO_HEIGHT_WITH_BUTTON : $a3457201b6f3f636$var$TEMPLATE_INFO_HEIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $a3457201b6f3f636$var$styles.templateInfoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        xcss: $a3457201b6f3f636$var$styles.templateInfo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c2cyb.TemplateIcon), {
        template: template,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3457201b6f3f636$var$TemplateName, null, template.name)), (0, $6mKj3.expVal)('confluence_cwr_template_right_rail', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9xorX.CreateWithRovoTemplateButton), {
        template: template,
        spaceKey: spaceKey,
        onModalOpen: hidePreview
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a3457201b6f3f636$var$Wrapper, {
        templateInfoHeight: template ? (0, $6mKj3.expVal)('confluence_cwr_template_right_rail', 'isEnabled', false) ? $a3457201b6f3f636$var$TEMPLATE_INFO_HEIGHT_WITH_BUTTON : $a3457201b6f3f636$var$TEMPLATE_INFO_HEIGHT : null
    }, children));



var $5QLLH = parcelRequire("5QLLH");


var $bkTn0 = parcelRequire("bkTn0");

const $387e1ff66cbdcb74$var$HIDE_TIMEOUT = 250;
const $387e1ff66cbdcb74$var$RENDER_DEBOUNCE_TIME = 80;
const $387e1ff66cbdcb74$var$PreviewContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { top: top, left: left, isVisible: isVisible, isEditorView: isEditorView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bsv5hl": (0, $7sObp.default)(`${__cmplp.top}px`),
            "--_t50dub": (0, $7sObp.default)(`${__cmplp.left}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_154ikz78 _1ltvdw55",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isVisible ? "_lcxv1wug" : "_lcxvglyw",
            __cmplp.isEditorView ? "_kqsw1n9t" : "_kqswstnw",
            __cmplp.isVisible ? "_v5641t3i" : "_v564glyw",
            __cmplp.className
        ])
    });
});
const $387e1ff66cbdcb74$var$PopupPreviewComponent = ({ spaceKey: spaceKey, templates: templates, numPreviewsToFetchAtOnce: numPreviewsToFetchAtOnce, hasDynamicPositioning: hasDynamicPositioning = false, isEditorView: isEditorView = true, hoverSource: hoverSource, searchQuery: searchQuery, renderedCategoryIds: renderedCategoryIds, children: children, isBottomPositioned: isBottomPositioned, isHorizontallyCentered: isHorizontallyCentered })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [currentTemplate, setCurrentTemplate] = (0, $42omo.useState)();
    const [position, setPosition] = (0, $42omo.useState)({
        top: -1000,
        left: -1000
    });
    const [templateIndex, setTemplateIndex] = (0, $42omo.useState)(-1);
    const previewRef = (0, $42omo.useRef)();
    const hideTimeout = (0, $42omo.useRef)(null);
    const currentTemplateRef = (0, $42omo.useRef)();
    const debouncedSetTemplateAndIndex = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(async (template, templateIndex)=>{
            setTemplateIndex(templateIndex);
            setCurrentTemplate(template);
            currentTemplateRef.current = template;
        }, $387e1ff66cbdcb74$var$RENDER_DEBOUNCE_TIME), []);
    const resumePreview = (0, $42omo.useCallback)(()=>{
        if (hideTimeout.current) {
            clearTimeout(hideTimeout.current);
            hideTimeout.current = null;
        }
    }, []);
    const showPreview = (0, $42omo.useCallback)(async (template, relativeCoordinates, templateIndex)=>{
        if (!previewRef.current) return;
        resumePreview(); // we use ref, not state (currentTemplate) here, since state should
        // be added as a dependency to useEffect
        // currentTemplate changes quite often, this would lead to
        // change of showPreview handler, and that would result
        // in re-render of component that consumes showPreview via render props
        if (currentTemplateRef.current && (0, $bkTn0.getTemplateId)(currentTemplateRef.current) === (0, $bkTn0.getTemplateId)(template)) {
            experienceTracker.abort({
                name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE),
                reason: 'Template preview is already being displayed'
            });
            return;
        }
        const position = (0, $bkTn0.calculatePreviewPosition)(previewRef.current.getBoundingClientRect(), relativeCoordinates, hasDynamicPositioning, isBottomPositioned, isHorizontallyCentered);
        setPosition(position);
        await debouncedSetTemplateAndIndex(template, templateIndex);
    }, [
        resumePreview,
        debouncedSetTemplateAndIndex,
        experienceTracker,
        hasDynamicPositioning,
        isBottomPositioned,
        isHorizontallyCentered
    ]);
    const hidePreview = (0, $42omo.useCallback)(()=>{
        if (hideTimeout.current) return;
        hideTimeout.current = window.setTimeout(()=>{
            currentTemplateRef.current = undefined;
            setCurrentTemplate(undefined);
            hideTimeout.current = null;
            setPosition({
                top: -1000,
                left: -1000
            });
        }, $387e1ff66cbdcb74$var$HIDE_TIMEOUT);
    }, []);
    const renderProps = (0, $42omo.useMemo)(()=>({
            showPreview: showPreview,
            hidePreview: hidePreview
        }), [
        showPreview,
        hidePreview
    ]); // handles starring updates since the templates list gets updated but the order doesn't change nor do the previews
    (0, $42omo.useEffect)(()=>{
        if (templates.length - 1 < templateIndex) // hide preview since the template no longer exists and has been unstarred
        // happens when the last template in the rendered list has been unstarred
        hidePreview();
    }, [
        templates,
        hidePreview,
        templateIndex
    ]); // prefetch first N template previews
    // when category or search changes
    (0, $42omo.useEffect)(()=>{
        if (templates.length && templateIndex !== -1) setTemplateIndex(0);
         // intentionally run this hook only when `category or searchquery` changes, not `templateIndex` or `templates`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery,
        renderedCategoryIds
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('resize', hidePreview);
        return ()=>window.removeEventListener('resize', hidePreview);
    }, [
        hidePreview
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: isEditorView ? (0, $g5lKx.layers).tooltip() : 13
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($387e1ff66cbdcb74$var$PreviewContainer, {
        ref: previewRef,
        onMouseEnter: resumePreview,
        onMouseLeave: hidePreview,
        top: position.top,
        left: position.left,
        isVisible: !!currentTemplate,
        isEditorView: isEditorView,
        "data-testid": "template-preview-container",
        ...!!currentTemplate ? {} : {
            'aria-hidden': true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5rdE.PreviewAnalyticsProvider), {
        template: currentTemplate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $df08ca4e4b70ce05$export$c97368b009d9ec7f), {
        source: hoverSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a3457201b6f3f636$export$633731da8c821a2a), {
        template: currentTemplate,
        spaceKey: spaceKey,
        hidePreview: hidePreview,
        isBottomPositioned: isBottomPositioned
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5QLLH.TemplatePreview), {
        spaceKey: spaceKey,
        templates: templates,
        currentTemplateIndex: templateIndex,
        numPreviewsToFetchAtOnce: numPreviewsToFetchAtOnce,
        marginBottom: 0,
        isScrollable: true
    }))))))), children(renderProps));
};
const $387e1ff66cbdcb74$export$65c74394172c28e5 = /*#__PURE__*/ (0, $42omo.memo)($387e1ff66cbdcb74$var$PopupPreviewComponent);
module.exports["PopupPreview"] = $387e1ff66cbdcb74$export$65c74394172c28e5;

});

parcelRegister("9xorX", function(module, exports) {

var $a6JMj = parcelRequire("a6JMj");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $ccHMk = parcelRequire("ccHMk");


var $h7YX1 = parcelRequire("h7YX1");


var $83Z6R = parcelRequire("83Z6R");


var $bQm3c = parcelRequire("bQm3c");


var $i88Ef = parcelRequire("i88Ef");


var $cHYDu = parcelRequire("cHYDu");

const $611bb0e525d18283$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    createWithRovoButton: {
        id: "smart-create.create-with-rovo-template-button",
        defaultMessage: "Create with Rovo"
    }
});
const $611bb0e525d18283$var$CreateWithRovoTemplateButtonTemplatesQuery = (0, $a6JMj.default);
const $611bb0e525d18283$export$9fea881b62f7886 = new Map();
const $611bb0e525d18283$var$getTemplateIdForQuery = (template)=>{
    return template.contentBlueprintId || template.templateId || template.itemModuleCompleteKey;
};
const $611bb0e525d18283$export$176583e1455fb40e = ({ template: template, spaceKey: spaceKey, onModalOpen: onModalOpen })=>{
    const intl = (0, $1cfRh.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const fetchTemplateBodies = (0, $83Z6R.useLazyQueryPromiseInterop)($611bb0e525d18283$var$CreateWithRovoTemplateButtonTemplatesQuery);
    const openModalWithTemplate = (0, $cHYDu.useOpenModalWithTemplate)({
        assistanceServiceParams: {
            product: 'confluence',
            experienceId: 'ai-mate',
            touchpointSource: 'template-gallery-smart-create',
            siteId: cloudId ?? ''
        }
    });
    const fetchTemplateAdf = (0, $42omo.useCallback)(async ()=>{
        const templateId = $611bb0e525d18283$var$getTemplateIdForQuery(template);
        const cacheKey = `${spaceKey}:${templateId}`;
        const cachedTemplateBody = $611bb0e525d18283$export$9fea881b62f7886.get(cacheKey);
        if (cachedTemplateBody !== undefined) return cachedTemplateBody;
        const templateBodiesData = await fetchTemplateBodies({
            variables: {
                spaceKey: spaceKey,
                ids: [
                    templateId
                ]
            }
        });
        const templateNode = templateBodiesData?.templateBodies?.nodes?.find((node)=>node?.id === templateId);
        const { value: adfBody, representation: representation } = templateNode?.body ?? {};
        if (!adfBody || representation !== 'atlas_doc_format') return undefined;
        $611bb0e525d18283$export$9fea881b62f7886.set(cacheKey, adfBody);
        return adfBody;
    }, [
        fetchTemplateBodies,
        spaceKey,
        template
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            if (!cloudId) {
                // TODO Add error handling https://hello.jira.atlassian.cloud/browse/AIFC-1490
                setIsLoading(false);
                return;
            }
            const stagedResponse = await (0, $i88Ef.createStagedSmartCreateDraft)(cloudId);
            const contentId = stagedResponse.contentId;
            if (!contentId) {
                // TODO Add error handling https://hello.jira.atlassian.cloud/browse/AIFC-1490
                setIsLoading(false);
                return;
            }
            const adfBody = await fetchTemplateAdf();
            if (!adfBody) {
                // TODO Add error handling https://hello.jira.atlassian.cloud/browse/AIFC-1490
                setIsLoading(false);
                return;
            }
            await openModalWithTemplate({
                contentId: contentId,
                adfBody: adfBody,
                templateName: template.name || '',
                spaceKey: spaceKey,
                onOpenCallback: ()=>{
                    onModalOpen?.();
                    setIsLoading(false);
                }
            });
        } catch (error) {
            // TODO Add error handling https://hello.jira.atlassian.cloud/browse/AIFC-1490
            setIsLoading(false);
            return error;
        }
    }, [
        cloudId,
        template,
        spaceKey,
        fetchTemplateAdf,
        openModalWithTemplate,
        onModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        onClick: handleClick,
        isLoading: isLoading,
        testId: "create-with-rovo-button"
    }, intl.formatMessage($611bb0e525d18283$export$a7357cdd1f0b0168.createWithRovoButton));
};
module.exports["CreateWithRovoTemplateButton"] = $611bb0e525d18283$export$176583e1455fb40e;

});

parcelRegister("a6JMj", function(module, exports) {
/**
 * @generated SignedSource<<e8fa21b5c1bba9cf3f97a7e9169414d7>>
 * @relayHash 265b6fe4cbfa044f1ab40096cb493b63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f8a1ee157d04b6ef78b6a93ec05e9a843fbfaf25b1c9547bbf4a4e119edcbdf
const $b39e11274bc9ce90$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "ids"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedTemplateBodyList",
            "kind": "LinkedField",
            "name": "templateBodies",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateBody",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "representation"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateWithRovoTemplateButtonTemplatesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateWithRovoTemplateButtonTemplatesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "265b6fe4cbfa044f1ab40096cb493b63",
            "id": "3f8a1ee157d04b6ef78b6a93ec05e9a843fbfaf25b1c9547bbf4a4e119edcbdf",
            "metadata": {},
            "name": "CreateWithRovoTemplateButtonTemplatesQuery",
            "operationKind": "query",
            "text": "query CreateWithRovoTemplateButtonTemplatesQuery($spaceKey:String!,$ids:[String!]!){templateBodies(spaceKey:$spaceKey,ids:$ids){nodes{id,body{value,representation}}}}"
        }
    };
}();
$b39e11274bc9ce90$var$node.hash = "fb2c221974b3d859a17bc8058bcf89d8";
var $b39e11274bc9ce90$export$2e2bcd8739ae039 = $b39e11274bc9ce90$var$node;
module.exports["default"] = $b39e11274bc9ce90$export$2e2bcd8739ae039;

});

parcelRegister("i88Ef", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $cf423cbabe6f0423$export$e0e844c00aabd6e7 = async (cloudId)=>{
    const data = await (0, $8Igpw.performHttpFetch)({
        path: `/gateway/api/ex/confluence/${cloudId}/wiki/rest/internals/latest/smart-create/staged`,
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'page'
            })
        }
    });
    return {
        contentId: String(data.id),
        type: data.type
    };
};
module.exports["createStagedSmartCreateDraft"] = $cf423cbabe6f0423$export$e0e844c00aabd6e7;

});

parcelRegister("cHYDu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $inPa6 = parcelRequire("inPa6");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $3vCSA = parcelRequire("3vCSA");


var $h26dv = parcelRequire("h26dv");


var $bPHr8 = parcelRequire("bPHr8");

var $i1Nyn = parcelRequire("i1Nyn");

var $jEzab = parcelRequire("jEzab");

var $2O3ot = parcelRequire("2O3ot");


var $aouqA = parcelRequire("aouqA");


var $jyA9t = parcelRequire("jyA9t");

const $728b462d4207cbbf$var$i18n = (0, $h82at.defineMessages)({
    createFromTemplate: {
        id: "smart-create.open-modal-with-template.create-from-template",
        defaultMessage: "Create from template: {templateName}"
    },
    templateSelectedHeading: {
        id: "smart-create.open-modal-with-template.template-selected-heading",
        defaultMessage: "Here's the template you selected. Let's start editing together."
    },
    templateSelectedDescription: {
        id: "smart-create.open-modal-with-template.template-selected-description",
        defaultMessage: "Ask for recommended next steps or tell me exactly how you would like the template filled out."
    },
    recentWork: {
        id: "smart-create.open-modal-with-template.recent-work",
        defaultMessage: "Fill this template using recent work"
    },
    recommendation: {
        id: "smart-create.open-modal-with-template.recommendation",
        defaultMessage: "What do you recommend doing?"
    }
});
/**
 * Opens the Create with Rovo smart creation modal pre-loaded with template content.
 *
 * Bypasses the normal generation step by creating a real backend conversation
 * via createConversationChannel with a pre-seeded CONFLUENCE_AIFC_PAGE_CREATE_KEY
 * action carrying the template ADF. The caller must create a staged draft first and pass its contentId.
 */ const $728b462d4207cbbf$var$useOpenModalWithTemplateImpl = ({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setTarget: setTarget } = (0, $i1Nyn.useChatContextStoreActions)();
    const { setStagingAreaMode: setStagingAreaMode, resetStagingArea: resetStagingArea, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview } = (0, $2O3ot.useStagingAreaActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { seedConversation: seedConversation, processConversationMessages: processConversationMessages } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const { setMessages: setMessages } = (0, $jEzab.useChatMessagesActions)();
    return (0, $42omo.useCallback)(async ({ contentId: contentId, adfBody: adfBody, templateName: templateName, spaceKey: spaceKey, onOpenCallback: onOpenCallback })=>{
        const invocationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        // Build the action payload to be included in the agent message.
        const action = {
            key: (0, $3vCSA.CONFLUENCE_AIFC_PAGE_CREATE_KEY),
            invocation_id: invocationId,
            planned_data: {
                title: templateName,
                adf: adfBody,
                contentId: contentId,
                type: 'page'
            },
            status: 'FINISHED',
            display_name: formatMessage($728b462d4207cbbf$var$i18n.createFromTemplate, {
                templateName: templateName
            })
        };
        // Build the dialogue (human + agent messages) to seed the conversation.
        const dialogue = {
            human_message: {
                content: ''
            },
            agent_message: {
                content: [
                    `## ${formatMessage($728b462d4207cbbf$var$i18n.templateSelectedHeading)}`,
                    formatMessage($728b462d4207cbbf$var$i18n.templateSelectedDescription)
                ].join('\n\n'),
                mimeType: 'text/markdown',
                actions: [
                    action
                ]
            }
        };
        // Create backend conversation with the seeded action
        const channel = await assistanceService.createConversationChannel({
            dialogues: [
                dialogue
            ]
        });
        const conversationId = channel.id;
        // Register the staged draft as the staging-area target
        setTarget('staging-area', {
            id: contentId,
            type: 'page',
            canProvideContext: true
        });
        // Register the conversation using seedConversation (a plain setState action).
        // createConversationOptimistically/createSeededConversation use createSafeAction
        // which requires ChatStoreContainer's containerProps — unavailable here since
        // the template gallery and GlobalComponents are siblings of RightPanel.
        // skipNextFetch: true prevents ChatStoreContainer from re-fetching the conversation
        // on mount, which would overwrite the locally-seeded messages including follow-ups.
        seedConversation({
            conversationId: conversationId,
            skipNextFetch: true
        });
        // Fetch and transform messages into the store format.
        const chat = await assistanceService.getChat(conversationId);
        const storeMessages = processConversationMessages({
            latestMessages: chat ?? [],
            conversationId: conversationId,
            sendAnalyticsEvent: (payload)=>createAnalyticsEvent(payload).fire()
        });
        if (storeMessages.length > 0) {
            // Required so useSelectedPreview knows which message drives the finalize popup.
            const assistantMsg = storeMessages.find((0, $bPHr8.isStoreAssistant));
            const assistantMsgId = assistantMsg?.content?.message?.message?.id;
            // Append synthetic follow-up prompts directly. Since seedConversation was called
            // with skipNextFetch: true, ChatStoreContainer will not re-fetch and overwrite these.
            const followUpItem = {
                type: 'FOLLOW_UP',
                content: {
                    type: 'FOLLOW_UP_QUERIES',
                    message: {
                        follow_ups: [
                            {
                                type: 'SYNTHETIC',
                                text: formatMessage($728b462d4207cbbf$var$i18n.recentWork)
                            },
                            {
                                type: 'SYNTHETIC',
                                text: formatMessage($728b462d4207cbbf$var$i18n.recommendation)
                            }
                        ]
                    },
                    millisOffset: 0
                },
                id: Date.now()
            };
            setMessages(conversationId, [
                ...storeMessages,
                followUpItem
            ]);
            if (assistantMsgId) setMessageIdSelectedForPreview(assistantMsgId);
        }
        // Mark as template flow so follow-up prompts target the existing staged draft.
        setStagingAreaMode('modal', 'template-smartCreate');
        openModal({
            entryPoint: 'template-smartCreate',
            spaceKey: spaceKey,
            stagingAreaActive: true,
            content: {
                id: contentId,
                type: 'page'
            },
            // Prevents re-open loops — handleClose doesn't call resetStagingArea by default.
            onCloseCallback: resetStagingArea,
            onOpenCallback: onOpenCallback
        });
    }, [
        assistanceService,
        createAnalyticsEvent,
        formatMessage,
        openModal,
        processConversationMessages,
        resetStagingArea,
        seedConversation,
        setMessageIdSelectedForPreview,
        setMessages,
        setStagingAreaMode,
        setTarget
    ]);
};
const $728b462d4207cbbf$export$8a73e0e690bd440f = (0, $h26dv.createHookWithAssistanceService)($728b462d4207cbbf$var$useOpenModalWithTemplateImpl);
module.exports["useOpenModalWithTemplate"] = $728b462d4207cbbf$export$8a73e0e690bd440f;

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSource: dynamicUiSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: undefined,
                dynamicUiType: undefined,
                dynamicUiSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useMessageIdSelectedForPreview"] = $abb9e481ac8f38e8$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("aouqA", function(module, exports) {

var $ajfvU = parcelRequire("ajfvU");

function $79be80eb0ef13a18$export$5650c329b9f287fb() {
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $ajfvU.useChatStore)();
    const { createConversationOptimistically: createConversationOptimistically, setSelectedConversation: setSelectedConversation, sendMessage: sendMessage, abortRequests: abortRequests, seedConversation: seedConversation } = (0, $ajfvU.useChatStoreActions)();
    const activeConversation = conversations[currentConversationId];
    return {
        createConversationOptimistically: createConversationOptimistically,
        setSelectedConversation: setSelectedConversation,
        abortRequests: abortRequests,
        activeConversationId: currentConversationId,
        activeConversation: activeConversation,
        sendMessage: sendMessage,
        seedConversation: seedConversation,
        processConversationMessages: $ajfvU.processConversationMessages
    };
}
module.exports["useSmartCreationChatStoreApi"] = $79be80eb0ef13a18$export$5650c329b9f287fb;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialOutcomeType: undefined,
    remixConversationId: null,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialOutcomeType: initialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, remixConversationId: remixConversationIdFromOpen })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialOutcomeType: initialOutcomeType ?? undefined,
                remixConversationId: remixConversationId,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialOutcomeType: undefined,
                remixConversationId: null,
                onCloseCallback: undefined,
                onOpenCallback: undefined
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("b4zhJ", function(module, exports) {

var $dM1Gg = parcelRequire("dM1Gg");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

const $4b5152b7d142b759$var$isClickable = (props)=>!!props.onClick;
class $4b5152b7d142b759$export$6341f9a885713487 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dM1Gg.DateLozenge), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            onClick: $4b5152b7d142b759$var$isClickable(this.props) ? this.handleOnClick : undefined,
            color: this.props.color
        }, this.renderContent());
    }
    constructor(...args){
        super(...args);
        this.handleOnClick = (event)=>{
            if ($4b5152b7d142b759$var$isClickable(this.props)) this.props.onClick(this.props.value, event);
        };
        this.renderContent = ()=>{
            if (this.props.children) {
                if (typeof this.props.children === 'function') return(// prettier-ignore
                // eslint-disable-next-line @typescript-eslint/ban-types
                this.props.children(this.props));
                return this.props.children;
            }
            return (0, $dWCFT.default)(this.props.value, this.props.format || '');
        };
    }
}
$4b5152b7d142b759$export$6341f9a885713487.displayName = 'Date';
$4b5152b7d142b759$export$6341f9a885713487.defaultProps = {
    format: 'dd/MM/yyyy',
    color: 'grey'
};
module.exports["Date"] = $4b5152b7d142b759$export$6341f9a885713487;

});

parcelRegister("dM1Gg", function(module, exports) {
/* DateLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $6603fd6b25dc5551$var$baseStyles = null;
const $6603fd6b25dc5551$var$onClickStyles = null;
const $6603fd6b25dc5551$var$colorStyles = {
    red: "_bfhk1vk5 _syaz9lu1 _irr31rtt",
    yellow: "_bfhkibhp _syazfb2s _irr31773",
    blue: "_bfhk1s93 _syaz16jw _irr31dy8",
    green: "_bfhkn729 _syazh55r _irr31wnw",
    purple: "_bfhkp2ly _syazqmo9 _irr31nm4",
    grey: "_bfhki8nm _syazi7uo _irr3plhp"
};
const $6603fd6b25dc5551$export$a9273d5fc6f7142c = (props)=>{
    const { className: className, color: color = 'grey', children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...rest,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od",
            props.onClick && "_80omtlke",
            $6603fd6b25dc5551$var$colorStyles[color],
            className
        ]),
        role: "button"
    }, children);
};
module.exports["DateLozenge"] = $6603fd6b25dc5551$export$a9273d5fc6f7142c;

});

parcelRegister("cBi7Q", function(module, exports) {
const $a428bcb8f1a15d17$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $a428bcb8f1a15d17$export$c87b1e2e3344192f = 1000;
const $a428bcb8f1a15d17$export$c4e7b6208a0b853e = 60;
const $a428bcb8f1a15d17$export$cd6b7e688e614eeb = $a428bcb8f1a15d17$export$c4e7b6208a0b853e * 60;
const $a428bcb8f1a15d17$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $a428bcb8f1a15d17$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $a428bcb8f1a15d17$export$e5a3af287978673c = (siteId)=>siteId ? `${$a428bcb8f1a15d17$export$a0d33d6e93abfb90}_${siteId}` : $a428bcb8f1a15d17$export$a0d33d6e93abfb90;
const $a428bcb8f1a15d17$export$e8114853eca81277 = 'ai-mate';
const $a428bcb8f1a15d17$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $a428bcb8f1a15d17$export$1ea9613e3e37d315 = 30 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$501af059da333e01 = 5 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $a428bcb8f1a15d17$export$85d90d98449e85fd = 140;
const $a428bcb8f1a15d17$export$cad0f6e78cd99203 = '600px';
const $a428bcb8f1a15d17$export$900371d5fadf47e7 = {
    NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
    THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button'
};
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $a428bcb8f1a15d17$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $a428bcb8f1a15d17$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $a428bcb8f1a15d17$export$cd6b7e688e614eeb;
module.exports["getChatLoadPreferenceKey"] = $a428bcb8f1a15d17$export$e5a3af287978673c;
module.exports["AI_MATE_EXPERIENCE_ID"] = $a428bcb8f1a15d17$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $a428bcb8f1a15d17$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $a428bcb8f1a15d17$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $a428bcb8f1a15d17$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $a428bcb8f1a15d17$export$cad0f6e78cd99203;
module.exports["POLLINATOR_TEST_IDS"] = $a428bcb8f1a15d17$export$900371d5fadf47e7;

});

parcelRegister("kBU5m", function(module, exports) {
// featureFlags should come from getSessionData in @confluence/session-data
// IMPORTANT: If you change the code below, please also update the
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
function $d887a76516ca8f8c$export$88f94a4dc797781a(featureFlags) {
    return featureFlags ? {
        mediaInline: true
    } : {};
}
module.exports["getMediaFeatureFlags"] = $d887a76516ca8f8c$export$88f94a4dc797781a;

});


//# sourceMappingURL=PopupPreview.b0be38e4.js.map
